import { ButtonTab } from "@/components/Button/ButtonTab"
import { PaymentSystem } from "@usher/pe-client-front-end-lib"

interface Props {
  value: PaymentSystem
  onChange: (value: PaymentSystem) => void
  disabled?: boolean
}
export const PaymentSystemSelect = ({ disabled, onChange, value }: Props) => {
  return (
    <div className="mt-4">
      <div className="">
        <h3 className="text-lg text-main-main">Please choose transfer type</h3>
      </div>
      <ButtonTab
        className="m-0 mt-2 [&>button]:w-full [&>button]:min-w-fit"
        items={[
          {
            title: "EUR (SEPA) - for Euro payments within the EU and EEA",
            active: value === PaymentSystem.SEPA,
            onClick() {
              if (disabled) return
              onChange(PaymentSystem.SEPA)
            },
          },
          {
            title: "USD (SWIFT) - for international USD transfers",
            active: value === PaymentSystem.SWIFT,
            onClick() {
              if (disabled) return
              onChange(PaymentSystem.SWIFT)
            },
          },
        ]}
      />
    </div>
  )
}
